import Cookies from 'js-cookie';
/****** KMS Pop Ups ******/
function removeModal(remove_timer, modalOverlay, modal){
    clearTimeout(remove_timer);
    modalOverlay.parentNode.removeChild(modalOverlay);
    modal.parentNode.removeChild(modal);
}
function closeModal(popup_closed_id, remove_timer, modalOverlay, modal){
    //Fades out the modal
    Cookies.set(popup_closed_id, true, { expires: 90 });
    modal.addEventListener("transitionEnd", () => {removeModal(remove_timer, modalOverlay, modal)});
    modalOverlay.addEventListener("transitionEnd", () => {removeModal(remove_timer, modalOverlay, modal)});
    remove_timer = setTimeout(() => {removeModal(remove_timer, modalOverlay, modal)}, 500); // Back up if transition doesn't fire
    modal.className += " kms-modal-closed";
    modalOverlay.className += " kms-modal-closed";
    window.removeEventListener('resize', setHeight);
    window.removeEventListener('load', setHeight);
}
function setHeight(modal, modalContent){
    modal.style.height = 'auto';
    //Rounding to 2 pixels prevents anti-aliasing blur
    modal.style.height = Math.ceil(modalContent.scrollHeight /2) * 2 + 'px';
}
export function runPopups() {
    var modal = document.querySelector("#modal");
    if (modal){
        var popup_id = modal.dataset.popupId;
        var modalOverlay = document.querySelector("#modal-overlay");
        var popup_closed_id = `popup-closed-${popup_id}`;
        var popup_seen = Cookies.get(popup_closed_id);
        if (popup_seen) {
            modal.parentNode.removeChild(modal);
            modalOverlay.parentNode.removeChild(modalOverlay);
            return;
        }
        var modalContent = modal.querySelector('.kms-modal-content');
        var closeButton = document.querySelector("#close-button");
        var remove_timer = null;

        setHeight(modal, modalContent);
        closeButton.addEventListener("click", () => {closeModal(popup_closed_id, remove_timer, modalOverlay, modal)});
        window.addEventListener('load', () => {setHeight(modal, modalContent)});
        window.addEventListener('resize', () => {setHeight(modal, modalContent)});
    }
}
